export default function () {
  return [
    {
      title: {
        pl: 'Strona główna',
        en: 'Homepage'
      },
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: '',
      permission: 'home'
    },
    {
      title: {
        pl: 'Statystyki',
        en: 'Stats'
      },
      to: '/statystyki',
      htmlBefore: '<i class="material-icons">poll</i>',
      htmlAfter: '',
      permission: 'stats'
    },
    {
      title: {
        pl: 'Powiadomienia',
        en: 'Notifications'
      },
      to: '/powiadomienia',
      htmlBefore: '<i class="material-icons">alarm</i>',
      htmlAfter: '',
      permission: 'notifications'
    },
    {
      title: {
        pl: 'Zamówienia',
        en: 'Orders'
      },
      to: '/zamowienia',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permission: 'orders',
      counter: 'orders'
    },
    {
      title: {
        pl: 'Oferty',
        en: 'Offers'
      },
      to: '/oferty',
      htmlBefore: '<i class="material-icons">request_quote</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'not-customer-and-warehouseman',
      counter: 'offers'
    },
    {
      title: {
        pl: 'Zamówienia partnerów',
        en: 'Partner orders'
      },
      to: '/zamowienia-partnerow',
      htmlBefore: '<i class="material-icons">contact_support</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'not-warehouseman',
      counter: 'customer_orders'
    },
    {
      title: {
        pl: 'Zamówienia indent',
        en: 'Indent orders'
      },
      to: '/zamowienia-indent',
      htmlBefore: '<i class="material-icons">inventory</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'not-customer-and-warehouseman',
      counter: 'indent',
      items: [
        {
          title: {
            pl: 'Zamówienia indent',
            en: 'Indent orders'
          },
          to: '/zamowienia-indent'
        },
        {
          title: {
            pl: 'Rejestr indent',
            en: 'Indent registry'
          },
          to: '/rejestr-indent'
        }
      ]
    },
    {
      title: {
        pl: 'Oferty Indent',
        en: 'Indent Offers'
      },
      to: '/oferty-indent',
      htmlBefore: '<i class="material-icons">request_quote</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'not-customer-and-warehouseman',
      counter: 'indent_offers'
    },
    {
      title: {
        pl: 'Do sprawdzenia na magazynie',
        en: 'To check in warehouse'
      },
      to: '/do-sprawdzenia',
      htmlBefore: '<i class="material-icons">fact_check</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'warehouseman'
    },
    {
      title: {
        pl: 'Oczekujące na dostawę',
        en: 'Waiting for delivery'
      },
      to: '/oczekujace-na-dostawe',
      htmlBefore: '<i class="material-icons">schedule</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'warehouseman'
    },
    {
      title: {
        pl: 'Wszystkie zamówienia',
        en: 'All orders'
      },
      to: '/zamowienia-wszystkie',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'warehouseman'
    },
    {
      title: {
        pl: 'Przesyłki',
        en: 'Shipments'
      },
      to: '/przesylki',
      htmlBefore: '<i class="material-icons">archive</i>',
      htmlAfter: '',
      permission: 'shipments',
      items: [
        {
          title: {
            pl: 'Przesyłki',
            en: 'Shipments'
          },
          to: '/przesylki'
        },
        {
          title: {
            pl: 'Raporty',
            en: 'Reports'
          },
          to: '/przesylki-raporty'
        }
      ]
    },
    {
      title: {
        pl: 'Agenci',
        en: 'Agents'
      },
      to: '/agenci',
      htmlBefore: '<i class="material-icons">work</i>',
      htmlAfter: '',
      permission: 'agents'
    },
    {
      title: {
        pl: 'Klienci',
        en: 'Customers'
      },
      to: '/klienci',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
      permission: 'customers'
    },
    {
      title: {
        pl: 'Kontakty z klientami',
        en: 'Contacts with customers'
      },
      to: '/kontakty-z-klientami',
      htmlBefore: '<i class="material-icons">call</i>',
      htmlAfter: '',
      permission: 'contacts'
    },
    {
      title: {
        pl: 'Potencjalni klienci',
        en: 'Potential customers'
      },
      to: '/potencjalni-klienci',
      htmlBefore: '<i class="material-icons">person_search</i>',
      htmlAfter: '',
      permission: 'potential_customers'
    },
    {
      title: {
        pl: 'Klienci z targów',
        en: 'Market customers'
      },
      to: '/klienci-z-targow',
      htmlBefore: '<i class="material-icons">person_search</i>',
      htmlAfter: '',
      permission: 'market_customers'
    },
    {
      title: {
        pl: 'Reklamacje',
        en: 'Complaints'
      },
      to: '/reklamacje',
      htmlBefore: '<i class="material-icons">rule</i>',
      htmlAfter: '',
      permission: 'complaints',
      userType: 'not-customer-and-warehouseman'
    },
    {
      title: {
        pl: 'KPI',
        en: 'KPI'
      },
      to: '/cele-pracownikow',
      htmlBefore: '<i class="material-icons">check_circle_outline</i>',
      htmlAfter: '',
      permission: 'kpi_targets',
      items: [
        {
          title: {
            pl: 'Cele pracowników',
            en: 'Workers targets'
          },
          to: '/cele-pracownikow'
        },
        {
          title: {
            pl: 'Realizacja KPI',
            en: 'KPI realisation'
          },
          to: '/realizacja-kpi'
        }
      ]
    },
    {
      title: {
        pl: 'Finanse',
        en: 'Finance'
      },
      to: '/rozliczenia',
      htmlBefore: '<i class="material-icons">attach_money</i>',
      htmlAfter: '',
      permission: 'settlements',
      items: [
        {
          title: {
            pl: 'Rozliczenia',
            en: 'Settlements'
          },
          to: '/rozliczenia'
        },
        {
          title: {
            pl: 'Raport zadłużeń',
            en: 'Debt report'
          },
          to: '/raport-zadluzen'
        }
      ]
    },
    {
      title: {
        pl: 'Planowanie zdobień',
        en: 'Services planning'
      },
      to: '/planowanie-zdobien',
      htmlBefore: '<i class="material-icons">table_chart</i>',
      htmlAfter: '',
      permission: 'services_schedule'
    },
    {
      title: {
        pl: 'Raporty',
        en: 'Reports'
      },
      to: '/raporty',
      htmlBefore: '<i class="material-icons">receipt_long</i>',
      htmlAfter: '',
      permission: 'reports'
    },
    {
      title: {
        pl: 'Cenniki',
        en: 'Prices'
      },
      htmlBefore: '<i class="material-icons">monetization_on</i>',
      htmlAfter: '',
      permission: 'prices',
      items: [
        {
          title: {
            pl: 'Cenniki produktów',
            en: 'Products prices'
          },
          to: '/cenniki/produkty'
        },
        {
          title: {
            pl: 'Cenniki zdobień',
            en: 'Services prices'
          },
          to: '/cenniki/zdobienia'
        },
        {
          title: {
            pl: 'Cenniki setup',
            en: 'Setup prices'
          },
          to: '/cenniki/setup'
        }
      ]
    },
    {
      title: {
        pl: 'Produkty',
        en: 'Products'
      },
      to: '/produkty',
      htmlBefore: '<i class="material-icons">shopping_basket</i>',
      htmlAfter: '',
      permission: 'products',
      items: [
        {
          title: {
            pl: 'Produkty HPL',
            en: 'HPL products'
          },
          to: '/produkty'
        },
        {
          title: {
            pl: 'Produkty Indent',
            en: 'Indent products'
          },
          to: '/produkty-indent'
        },
        {
          title: {
            pl: 'Tagi produktów',
            en: 'Product tags'
          },
          to: '/produkty/tagi'
        },
        {
          title: {
            pl: 'Kategorie',
            en: 'Categories'
          },
          to: '/kategorie-produktow'
        }
      ]
    },
    {
      title: {
        pl: 'Zdobienia',
        en: 'Services'
      },
      to: '/zdobienia',
      htmlBefore: '<i class="material-icons">star</i>',
      htmlAfter: '',
      permission: 'services',
      items: [
        {
          title: {
            pl: 'Zdobienia HPL',
            en: 'HPL services'
          },
          to: '/zdobienia'
        },
        {
          title: {
            pl: 'Zdobienia Indent',
            en: 'Indent services'
          },
          to: '/zdobienia-indent'
        },
        {
          title: {
            pl: 'Grupy zdobień',
            en: 'Services groups'
          },
          to: '/zdobienia/grupy'
        }
      ]
    },
    {
      title: {
        pl: 'Użytkownicy',
        en: 'Users'
      },
      to: '/uzytkownicy',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permission: 'users'
    },
    {
      title: {
        pl: 'Spedytorzy',
        en: 'Shippers'
      },
      to: '/spedytorzy',
      htmlBefore: '<i class="material-icons">local_shipping</i>',
      htmlAfter: '',
      permission: 'shippers'
    },
    {
      title: {
        pl: 'Wykonawcy',
        en: 'Contractors'
      },
      to: '/wykonawcy',
      htmlBefore: '<i class="material-icons">design_services</i>',
      htmlAfter: '',
      permission: 'contractors'
    },
    {
      title: {
        pl: 'Kontenery',
        en: 'Containers'
      },
      to: '/kontenery',
      htmlBefore: '<i class="material-icons">widgets</i>',
      htmlAfter: '',
      permission: 'containers'
    },
    {
      title: {
        pl: 'Kontenery - rezerwacje',
        en: 'Containers - resevations'
      },
      to: '/kontenery/rezerwacje',
      htmlBefore: '<i class="material-icons">lock</i>',
      htmlAfter: '',
      permission: 'containers'
    },
    {
      title: {
        pl: 'Zamówienia u dostawców',
        en: 'Purchases'
      },
      to: '/zakupy',
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      htmlAfter: '',
      permission: 'purchases'
    },
    {
      title: {
        pl: 'Rezerwacje u dostawców',
        en: 'Purchase reservations'
      },
      to: '/zakupy/rezerwacje',
      htmlBefore: '<i class="material-icons">lock</i>',
      htmlAfter: '',
      permission: 'purchases'
    },

    {
      title: {
        pl: 'Zamówienia w Hafciarni',
        en: 'Orders in Hafciarnia'
      },
      to: '/zamowienia-hafciarnia',
      htmlBefore: '<i class="material-icons">panorama_vertical_select</i>',
      htmlAfter: '',
      permission: 'orders',
      userType: 'not-customer-and-warehouseman',
    },

    {
      title: {
        pl: 'Twoje konto',
        en: 'Your account'
      },
      to: '/moje-konto',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permission: 'profile'
    },
    {
      title: {
        pl: 'Ustawienia',
        en: 'Settings'
      },
      to: '/ustawienia',
      htmlBefore: '<i class="material-icons">settings_applications</i>',
      htmlAfter: '',
      permission: 'settings',
      items: [
        {
          title: {
            pl: 'Kraje',
            en: 'Countries'
          },
          to: '/ustawienia/kraje'
        },
        {
          title: {
            pl: 'Języki',
            en: 'Languages'
          },
          to: '/ustawienia/jezyki'
        },
        {
          title: {
            pl: 'Waluty',
            en: 'Currencies'
          },
          to: '/ustawienia/waluty'
        },
        {
          title: {
            pl: 'Słowniki wielojęzyczności',
            en: 'Translation dictionaries'
          },
          to: '/ustawienia/slowniki-wielojezycznosci'
        },
        {
          title: {
            pl: 'Grupy użytkowników',
            en: 'User groups'
          },
          to: '/ustawienia/grupy-uzytkownikow'
        },
        {
          title: {
            pl: 'Tagi klientów',
            en: 'Customers tags'
          },
          to: '/ustawienia/tagi-klientow'
        },
        {
          title: {
            pl: 'Tagi zamówień',
            en: 'Orders tags'
          },
          to: '/ustawienia/tagi-zamowien'
        },
        {
          title: {
            pl: 'Typy kontaktów z klientem',
            en: 'Types of contacts with customer'
          },
          to: '/ustawienia/typy-kontaktow-z-klientem'
        },
        /*
        ,{
          title: {
            pl: 'Źródła pozyskania',
            en: 'Source of acquisition'
          },
          to: '/ustawienia/zrodla-pozyskania'
        },
        */
        {
          title: {
            pl: 'Czas realizacji',
            en: 'Processing times'
          },
          to: '/ustawienia/czas-realizacji'
        },
        {
          title: {
            pl: 'Integracje',
            en: 'Integrations'
          },
          to: '/ustawienia/integracje'
        },
        {
          title: {
            pl: 'Dodatkowe potwierdzenia',
            en: 'Additional confirmations'
          },
          to: '/ustawienia/potwierdzenia'
        },
        {
          title: {
            pl: 'Szablony e-mail',
            en: 'E-mail templates'
          },
          to: '/ustawienia/szablony-email'
        }
      ]
    },
    {
      title: {
        pl: 'Wyloguj się',
        en: 'Logout'
      },
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj',
      permission: false
    }
  ];
}
